import React, { useEffect, useState } from "react";
import { Button } from "antd";
import { ChevronDown, X } from "lucide-react";
import { useDispatch } from "react-redux";
import { getOrganisationData } from "../../../admin/api/Organisation";
import IMAGES from "../../../../constant/images";

export default function TopBar() {
  const dispatch = useDispatch();
  const [logo, setLogo] = useState(null);
  const [name, setName] = useState(null);
  const [username, setUsername] = useState(null);
  const [userImage, setUserImage] = useState(null);
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const getOrganisation = () => {
    // First check if data exists in localStorage
    const organisationData = JSON.parse(localStorage.getItem("organisationData"));
    if (organisationData) {
      // Use existing data
      setLogo(organisationData.organisationLogo);
      setName(organisationData.organisationName);
      setUserImage(organisationData.imageURL);

      const title = organisationData.title || "Mr/Ms";
      setUsername(
        `${title}. ${organisationData.firstName} ${organisationData.lastName}`
      );
    } else {
      // Fetch from API if not in localStorage
      dispatch(getOrganisationData()).then((res) => {
        if (res.payload.status === "success") {
          const orgData = res.payload.message.payload;

          // Save to localStorage
          localStorage.setItem("organisationData", JSON.stringify(orgData));
          localStorage.setItem("organisationId", orgData.organisationId);
          localStorage.setItem("email", orgData.email);
          localStorage.setItem("cid", orgData.pcUserId);
          localStorage.setItem("orgName", orgData.organisationName);

          // Set state
          setLogo(orgData.organisationLogo);
          setName(orgData.organisationName);
          setUserImage(orgData.imageURL);

          const title = orgData.title || "Mr/Ms";
          setUsername(
            `${title}. ${orgData.firstName} ${orgData.lastName}`
          );
        }
      });
    }
  };

  useEffect(() => {
    getOrganisation();
  }, []);

  const handleLogout = () => {
    localStorage.clear();
    window.location.href = "/";
  };

  const routes = [
    {
      slug: "my-bookings",
      title: "My Bookings",
      path: "/member/my-bookings",
      icon: IMAGES.white_appointment,
    },
    {
      slug: "events",
      title: "Events",
      path: "/member/events",
      icon: IMAGES.white_event,
    },
    {
      slug: "my-profile",
      title: "My Profile",
      path: "/member/profile",
      icon: IMAGES.member_white,
    },
    {
      slug: "assessments",
      title: "Assessments",
      path: "/member/assessments",
      icon: IMAGES.reports_icon,
    },
    {
      slug: "store",
      title: "Store",
      path: "/member/store",
      icon: IMAGES.store_icon,
    },
    {
      slug: "about-phybercare",
      title: "About Phybercare",
      path: "/member/about-phybercare",
      icon: IMAGES.phyber_logo_white,
    },
  ];

  const tools = [
    {
      slug: "notifications",
      title: "Notifications",
      path: "/member/notifications",
      icon: IMAGES.white_noti,
    },
    {
      slug: "support",
      title: "Support & Tickets",
      path: "/member/support",
      icon: IMAGES.help_icon,
    },
  ];

  const isDisabledRoute = (path) => {
    return path === "/member/events" ||
           path === "/member/assessments" ||
           path === "/member/store" ||
           path === "/member/about-phybercare" ||
           path === "/member/notifications";
  };

  const navigateItem = (path) => {
    setMenuOpen(false);
    if (isDisabledRoute(path)) {
      // Do nothing for disabled routes
      return;
    } else if (path === "/logout") {
      handleLogout();
    } else {
      window.location.href = path;
    }
  };

  return (
    <header className="fixed top-0 left-0 lg:left-[var(--sidebar-w,0px)] right-0 h-16 flex items-center py-2.5 px-4 md:px-8 border-b border-gray-200 shadow-xs justify-between font-poppins z-10 bg-white transition-all duration-300">
      {/* Left Section - Hamburger + Logo */}
      <div className="flex items-center space-x-3 md:w-[33%]">
        <Button
          className="block md:hidden bg-transparent border-0 p-0"
          onClick={() => setMenuOpen(true)}
        >
          <img
            alt="hamburger_menu"
            src={IMAGES.hamburger}
            className="w-7 h-7"
          />
        </Button>

        <a href="/member/dashboard" className="block">
          {logo ? (
            <img
              src={logo}
              alt="Organization logo"
              className="h-8 w-auto max-w-[160px] object-contain"
            />
          ) : (
            <div className="h-8 flex items-center justify-center">
              <img
                src={IMAGES.phyber_logo_white}
                alt="Phyber Logo"
                className="h-8 w-auto object-contain"
              />
            </div>
          )}
        </a>
      </div>

      {/* Search - not wired to anything yet, hidden until it is */}
      {/* <div className="hidden md:flex flex-1 justify-center">
        <div className="w-full max-w-[320px] h-[38px]">
          <Input
            type="text"
            placeholder="Search"
            className="w-full !h-[35px] px-3 rounded-xl border-1 border-gray-200 shadow-sm focus:ring-2 focus:ring-phyber-200 text-gray-700 bg-white placeholder:text-gray-400 text-sm"
            prefix={
              <img
                alt="search_icon"
                src={IMAGES.search_icon}
                className="w-5 h-5"
              />
            }
          />
        </div>
      </div> */}
      <div className="hidden md:flex flex-1" />

      {/* Right Section - Organisation, Notification, Profile */}
      <div className="flex items-center space-x-3">
        {/* Organisation */}
        {name && (
          <div className="hidden md:flex items-center space-x-2 bg-white border-[1px] border-solid border-gray-200 rounded-xl px-2 py-1 shadow-sm h-full">
            <img
              src={IMAGES.header_location}
              alt="location"
              className="w-[30px] h-[30px]"
            />
            <span className="text-xs font-semibold text-gray-800 leading-none block">
              {name}
            </span>
          </div>
        )}

        {/* Notification (visual only, notifications are not available for members yet) */}
        <div className="h-6 w-px bg-gray-200/80 hidden md:block rounded-full" />

        <div className="relative flex items-center h-full">
          <Button
            className="bg-transparent border-0 p-0 h-[38px] w-[38px] rounded-full hover:bg-gray-100 transition-colors flex items-center justify-center"
          >
            <img
              src={IMAGES.header_notification}
              alt="notification"
              className="w-[38px] h-[38px]"
            />
          </Button>
        </div>

        {/* Profile Section */}
        <div className="relative flex items-center space-x-2 p-1.5 pr-3 rounded-full border-[1px] border-solid border-transparent hover:bg-phyber-50 hover:border-phyber-100 transition-all group">
          {/* Profile Picture */}
          <div
            className="flex items-center justify-center w-9 h-9 rounded-full bg-[#F8FAFC] overflow-hidden cursor-pointer border-[1px] border-solid border-white shadow-sm flex-shrink-0"
            onClick={() => setShowProfileMenu(!showProfileMenu)}
          >
            {userImage ? (
              <img
                src={userImage}
                alt="profile"
                className="w-9 h-9 rounded-full object-cover"
              />
            ) : (
              <img
                src={IMAGES.user_filled}
                alt="profile"
                className="w-5 h-5 object-contain"
              />
            )}
          </div>

          {/* User Name and Dropdown Button */}
          <div className="hidden md:flex items-center">
            <button
              onClick={() => setShowProfileMenu(!showProfileMenu)}
              className="flex items-center gap-1 bg-transparent border-0 p-0 transition-colors"
            >
              <span className="text-xs font-semibold text-gray-800 group-hover:text-phyber-700 transition-colors">
                {username || "User"}
              </span>
              <ChevronDown size={14} className="text-[#64748B]" />
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      {menuOpen && (
        <div className="fixed inset-0 z-[9999] flex md:hidden">
          <div className="bg-white flex flex-col w-full h-full overflow-y-auto">
            <div className="min-h-screen bg-gradient-to-b from-blue-950 to-emerald-950 text-white flex flex-col justify-between">
              <div>
                {/* Mobile Menu Header */}
                <div className="p-4 flex justify-between items-center">
                  <div className="flex gap-2 items-center">
                    {logo ? (
                      <img src={logo} alt="Logo" className="w-9 h-9 rounded-full object-cover" />
                    ) : (
                      <img
                        src={IMAGES.location_mobile}
                        className="w-9 h-9"
                        alt="icon"
                      />
                    )}
                    <div>
                      <span className="text-xs block">{name || "Member"}</span>
                      <span className="font-semibold block">{username || "User"}</span>
                    </div>
                  </div>
                  <X
                    size={20}
                    className="cursor-pointer"
                    onClick={() => setMenuOpen(false)}
                  />
                </div>

                <div className="border-t border-white/10 my-2" />

                {/* Routes */}
                <div className="p-4 space-y-6">
                  {routes.map((item, key) => {
                    const disabled = isDisabledRoute(item.path);
                    return (
                      <div
                        key={key}
                        className={`flex items-center gap-3 ${
                          disabled
                            ? "cursor-not-allowed opacity-50"
                            : "cursor-pointer"
                        }`}
                        onClick={() => navigateItem(item.path)}
                      >
                        <img
                          src={item.icon}
                          alt={item.slug}
                          className="w-6 h-6"
                        />
                        <span className="text-sm">{item.title}</span>
                      </div>
                    );
                  })}
                </div>

                <div className="border-t border-white/10 my-2" />

                {/* Tools */}
                <div className="p-4">
                  <p className="text-xs mb-3">Tools</p>
                  <div className="space-y-6">
                    {tools.map((item, key) => {
                      const disabled = isDisabledRoute(item.path);
                      return (
                        <div
                          key={key}
                          className={`flex items-center gap-3 ${
                            disabled
                              ? "cursor-not-allowed opacity-50"
                              : "cursor-pointer"
                          }`}
                          onClick={() => navigateItem(item.path)}
                        >
                          <img
                            src={item.icon}
                            alt={item.slug}
                            className="w-6 h-6"
                          />
                          <span className="text-sm">{item.title}</span>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>

              {/* Mobile Menu Footer */}
              <div className="p-4 space-y-4">
                <div className="flex items-center">
                  <span className="text-sm">Powered by</span>
                  <img
                    src={IMAGES.footer_logo}
                    alt="footer_logo"
                    className="h-4 ml-1"
                  />
                </div>
                <div className="border-t border-white/10" />
                <div
                  className="flex items-center gap-3 cursor-pointer"
                  onClick={() => navigateItem("/logout")}
                >
                  <img
                    src={IMAGES.logout_icon}
                    alt="logout_icon"
                    className="w-6 h-6"
                  />
                  <span className="text-sm">Logout</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
